import StandardTable, {StandardColumnsType} from "../StandardTable";
import {Input, Modal, ModalProps} from "antd";
import useAntTable from "../../utils/useAntTable";
import * as dealerApi from "../../apis/dealer";
import {getDealerShippingListUrl} from "../../apis/dealer";
import {useEffect} from "react";
import AreaSelect from "../AreaSelect";



interface DealerShippingSelectModalProps extends ModalProps{
    multiple?:boolean,
    columns?:StandardColumnsType
    onComplete:(keys:number[], records:any[])=>void
    url?:string
    queryParams?:any
}
function DealerShippingSelectModal(props: DealerShippingSelectModalProps) {
    const {multiple=false, url, queryParams={}, onCancel, onOk, onComplete, columns=[], ...otherProps} = props;
    const {tableProps, form, search} = useAntTable(url||dealerApi.getDealerShippingListUrl,{selectTable: multiple || 'radio', defaultParams:{...queryParams}});

    const tableColumns = columns.length?columns:[
        {
            dataIndex: 'name',
            title: '名称'
        },
        {
            dataIndex: 'phone',
            title: '电话'
        },
        {
            dataIndex: 'provinceId',
            title: '省',
            render(v:number){
                return <AreaSelect type={"province"} value={v} disabled/>
            }
        },
        {
            dataIndex: 'cityId',
            title: '市',
            render(v: number) {
                return <AreaSelect type={'city'} value={v} disabled/>
            }
        },
        {
            dataIndex: 'address',
            title: '详细地址',

        }
    ];

    useEffect(() => {
        if(otherProps.open){
            resetSelected();
        }
    }, [otherProps.open]);

    const handleOk = (e:React.MouseEvent<HTMLButtonElement>)=>{
        onOk && onOk(e);
        onComplete && onComplete(tableProps?.rowSelection?.selectedRowKeys, tableProps?.rowSelection?.selectedRows);
    }

    const resetSelected = ()=>{
        tableProps?.rowSelection?.onChange([],[]);
    }



    return <Modal {...otherProps} width={1000} onCancel={onCancel} onOk={handleOk} destroyOnClose title={'地址选择'}>
        <StandardTable {...tableProps} rowKey={'id'} submit={form.submit} columns={tableColumns} form={form}/>
    </Modal>
}

export default DealerShippingSelectModal;